import { render } from "./flights.vue?vue&type=template&id=25b65252"
import script from "./flights.vue?vue&type=script&lang=js"
export * from "./flights.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__